module.exports = __webpack_public_path__ + "static/media/hi.04c16277.svg";